import React from 'react';
import { useSelector } from 'react-redux';
import ItemBlock from '../../itemBlock/ItemBlock';
import VideoPreview from '../../../../ui/videoPreview/VideoPreview';
import classes from './VideoGalleryBlock.module.css';

const VideoGalleryBlock = ({ title, text, videos = [] }) => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <ItemBlock title={title ? (texts[title] || title) : null}>
            <div className={classes.content}>
                {text && <p className={classes.text}>{texts[text] || text}</p>}
                {videos.length > 0 &&
                    <div className={classes.videosContainer}>
                        {videos.map((video, index) => (
                            <div key={index} className={classes.videoItem}>
                                <VideoPreview url={video.url} alt={video.alt || ""} duration={video.duration} />
                                {video.title &&
                                    <p className={classes.videoTitle}>
                                        {texts[video.title] || video.title}
                                    </p>
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </ItemBlock>
    );
};

export default VideoGalleryBlock;

